import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { Grid } from 'style';
import { Markdown } from '..';

const SideBySideTextComponent = ({
    left,
    right,
    backgroundColor,
    textColor,
}) => (
        <Grid.Wrapper
            backgroundColor={backgroundColor && backgroundColor.hex}
            textColor={textColor && textColor.hex}
            id="SideBySideTextComponent">
            <Grid.Container14>
                <Markdown source={left} css={left_css} />
                <Markdown source={right} css={right_css} />
            </Grid.Container14>
        </Grid.Wrapper>
    );

const Col = styled(Grid.Col)`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @media (min-width: 1024px) {
    }
`;
const right_css = css`
    flex: 1 0 50%;
    min-width: 290px;
    max-width: 100vw;
    white-space: pre-wrap;


    @media (min-width: ${290 * 2}px) {
      padding-left: 5.5vw;
      padding-right: 5.5vw;
    }

    > :first-child {
        margin-top: 0;
    }
`;
const left_css = css`
    ${right_css};
    /*
    padding-left: 0;
    padding-right: 5.5vw; */
    padding-bottom: 5.5vw;

    @media (orientation: portrait){
      padding-bottom: 5.5vh;
    }
    margin: 0;
`;

export default SideBySideTextComponent;
